export default {
  // props
  color: "#ea7f23",
  loader: "dots",
  opacity: 0.5,
  zIndex: 999,
  height: 100,
  width: 100,
};
